module.exports = __webpack_public_path__ + "static/media/dBanner5.130f4c2e.png";